export default "__VITE_ASSET__qEnapOhY__"